import Card from '@zenbusiness/zui/Card';
import PageContainer from '@zenbusiness/zui/PageContainer';
import { superstyled } from '@zenbusiness/zui/styles';

export const Root = superstyled({
  name: 'ZuiPageContainer',
  slot: 'Root',
  tag: PageContainer,
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '1.625rem',
    marginTop: theme.spacing(0),

    [theme.breakpoints.up('md')]: {
      marginTop: theme.spacing(0),
    },

    [theme.breakpoints.up('lg')]: {
      marginTop: theme.spacing(0),
    },
  }),
});

export const Content = superstyled({
  name: 'ZuiContent',
  slot: 'Root',
  tag: Card,
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
    borderColor: 'border.main',
  }),
});
